import React, { useState, useRef, useContext } from 'react';
import { TPAComponentsContext, FloatingDropdown } from 'wix-ui-tpa';
import { st, classes } from './PermissionsDropdown.st.css';
import EmptyLogo from '../../assets/icons/DropdownCheckedEmpty.svg';
import CheckedIcon from '../../assets/icons/DropdownChecked.svg';
import he from 'he';
import { Dropdown, DropdownBase, listItemSelectBuilder, TextButton, Box, } from '@wix/design-system';
import { ChevronDown, Delete, DownloadImport, Settings, Visible, } from '@wix/wix-ui-icons-common';
const permissionLevels = {
    VIEW: 'VIEW',
    CONTRIBUTE: 'CONTRIBUTE',
    MANAGE: 'MANAGE',
    NONE: 'NONE',
};
const getOverlay = () => {
    const div = document.createElement('div');
    div.style.position = 'fixed';
    div.style.left = '0';
    div.style.bottom = '0';
    div.style.right = '0';
    div.style.top = '0';
    return div;
};
function PermissionsDropdown(props) {
    const { mobile } = useContext(TPAComponentsContext);
    const overlay = useRef(getOverlay());
    const { options, className, ariaLabelledBy = '', isDashboard = false, isStep2 = false, shouldChangeColor = false, containerRef, } = props;
    const [selected, setSelected] = useState(props.value); // selected permission menu title
    const [step1MenuClassName, setStep1MenuClassName] = useState(st(classes.whiteColor));
    const getIcon = (id) => {
        return id === selected ? React.createElement(CheckedIcon, null) : React.createElement(EmptyLogo, null);
    };
    const dropDownChange = (e) => {
        if (!isDashboard) {
            if (!mobile) {
                lockScrolling(false);
            }
            setSelected(e.id?.toString());
        }
        if (!isStep2) {
            setStep1MenuClassName(st(classes.whiteColor));
        }
        if (props.onChange) {
            props.onChange(`${e.id}`);
        }
    };
    const getPermissionIcon = (permissionId) => {
        switch (permissionId) {
            case permissionLevels.VIEW:
                return React.createElement(Visible, null);
            case permissionLevels.CONTRIBUTE:
                return React.createElement(DownloadImport, null);
            case permissionLevels.MANAGE:
                return React.createElement(Settings, null);
            case permissionLevels.NONE:
                return React.createElement(Delete, null);
            default:
                return '';
        }
    };
    const newOptions = options.map((k) => {
        return {
            ...k,
            value: he.decode(k.value || ''),
            subtitle: he.decode(k.subtitle || ''),
            icon: getIcon(`${k.id}`),
            key: k.id,
        };
    });
    const lockScrolling = (expanded) => {
        const docBody = document.body;
        if (expanded) {
            docBody.appendChild(overlay.current);
        }
        else if (docBody.contains(overlay.current)) {
            docBody.removeChild(overlay.current);
        }
    };
    if (isDashboard) {
        const updatedOptions = options.map((permission) => {
            return permission.divider
                ? { value: '-', label: '', id: '' }
                : listItemSelectBuilder({
                    id: permission.id,
                    prefix: (React.createElement(Box, { paddingLeft: 1 }, getPermissionIcon(permission.id))),
                    title: permission.value,
                    subtitle: permission.subtitle,
                    label: permission.value,
                    className: st(classes.wsrOption, {
                        isLastChild: permission.id === permissionLevels.NONE,
                    }),
                });
        });
        const selectedPermission = updatedOptions.find((permission) => permission.id === props.value);
        const buttonClassName = shouldChangeColor ? step1MenuClassName : '';
        const updatedOptionsChildren = {
            children: updatedOptions,
            options: updatedOptions,
        };
        return isStep2 ? (React.createElement(Dropdown, { dropdownWidth: "320px", selectedId: selectedPermission?.id, popoverProps: {
                placement: 'bottom-end',
                appendTo: 'parent',
            }, className: className, onSelect: dropDownChange, valueParser: (option) => option.label, ...updatedOptionsChildren })) : (React.createElement(DropdownBase, { selectedId: selectedPermission?.id, maxWidth: "320px", minWidth: "320px", className: className, maxHeight: "348px", appendTo: buttonClassName ? `.${buttonClassName}` : 'scrollParent', onSelect: dropDownChange, placement: "bottom-end", overflow: "visible", flip: false, ...updatedOptionsChildren }, ({ toggle, selectedOption = {} }) => (React.createElement(TextButton, { skin: "dark", className: buttonClassName, onClick: toggle, suffixIcon: React.createElement(ChevronDown, null) }, (selectedOption.id !== 'NONE' && selectedOption.label) ||
            selectedPermission?.label))));
    }
    return (React.createElement(FloatingDropdown, { removeElementMinWidth: true, "aria-labelledby": ariaLabelledBy, options: newOptions, disabled: props.disabled, value: selected, label: "", onChange: dropDownChange, className: st(classes.permissionsDropdown, {
            isDisabled: props.disabled,
            mobile,
        }, className), appendTo: containerRef?.current, onExpandedChange: lockScrolling, placement: "bottom-start" }));
}
export default PermissionsDropdown;
//# sourceMappingURL=PermissionsDropdown.js.map